import React, { useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { usePageTitle } from "context/PageTitleContext";

const EquipmentBorrow = () => {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle("Lập phiếu mượn thiết bị");
  }, [setPageTitle]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            mb: 2,
            color: "text.primary",
          }}
        >
          Lập phiếu mượn thiết bị
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Inter, sans-serif",
            color: "text.secondary",
            mb: 3,
          }}
        >
          Tính năng đang được phát triển...
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/builder.png"
            alt="Đang phát triển"
            style={{
              maxWidth: "300px",
              width: "100%",
              height: "auto",
              opacity: 0.7,
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default EquipmentBorrow;
